import React from 'react';
import { Networking_06 as Networking06 } from '@carbon/pictograms-react';
import { EmptyState } from 'components/EmptyState';
import { Link } from 'carbon-components-react';

const EmptyStatePage: React.FC<Props> = ({
  organisationName,
  utilityId,
  resetSearch
}) => {
  return (
    <EmptyState>
      <div className="aoi-viewer-no-data--wrapper">
        <Networking06 />
        <div className="aoi-viewer-empty-state-heading">
          {organisationName} ({utilityId}) has no AOI defined yet
        </div>
        <div className="aoi-viewer-empty-state-sub-heading">
          <Link onClick={() => resetSearch()}>Please search again</Link>
        </div>
      </div>
    </EmptyState>
  );
};

type Props = {
  organisationName?: string;
  utilityId?: string;
  resetSearch: Function;
};

EmptyStatePage.displayName = 'EmptyStatePage';
export default EmptyStatePage;
